// @ts-nocheck
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type SubmitHandler, useForm } from "react-hook-form";

import {
  Button,
  DialogActionTrigger,
  ButtonGroup,
  DialogTitle,
  Input,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { type TableCreate, TablesService } from "../../client";
import type { ApiError } from "../../client/core/ApiError";
import useCustomToast from "../../hooks/useCustomToast";
import { handleError } from "../../utils";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTrigger,
} from "../ui/dialog";
import { Field } from "../ui/field";

const AddTable = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const queryClient = useQueryClient();
  const { showSuccessToast } = useCustomToast();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isValid, isSubmitting },
  } = useForm<TableCreate>({
    mode: "onBlur",
    criteriaMode: "all",
    defaultValues: {
      table_name: "",
      description: "",
    },
  });

  const mutation = useMutation({
    mutationFn: (data: TableCreate) =>
      TablesService.createTable({ requestBody: data }),
    onSuccess: () => {
      showSuccessToast("테이블이 성공적으로 생성되었습니다.");
      reset();
      setHasSubmitted(false);
      setIsOpen(false);
    },
    onError: (err: ApiError) => {
      handleError(err);
      setHasSubmitted(false);
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] === "tables" || query.queryKey[0] === "tablesList",
      });
    },
  });

  const onSubmit: SubmitHandler<TableCreate> = (data) => {
    if (hasSubmitted) return;
    setHasSubmitted(true);

    // Remove all spaces from table_name
    data.table_code = data.table_name.replace(/\s+/g, "");

    mutation.mutate(data);
  };

  return (
    <DialogRoot
      size={{ base: "xs", md: "md" }}
      placement="center"
      open={isOpen}
      onOpenChange={({ open }) => setIsOpen(open)}
    >
      <DialogTrigger asChild>
        <Button value="add-item" my={4}>
          <FaPlus fontSize="16px" />
          테이블 추가
        </Button>
      </DialogTrigger>
      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogHeader>
            <DialogTitle>테이블 추가</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <Text mb={4}>새 테이블을 추가하려면 세부 정보를 입력하세요.</Text>
            <VStack gap={4}>
              <Field
                required
                invalid={!!errors.table_name}
                errorText={errors.table_name?.message}
                label="이름"
              >
                <Input
                  id="table_name"
                  {...register("table_name", {
                    required: "Title is required.",
                  })}
                  placeholder="테이블 이름"
                  type="text"
                />
              </Field>

              <Field
                required
                invalid={!!errors.description}
                errorText={errors.description?.message}
                label="설명"
              >
                <Input
                  id="description"
                  {...register("description")}
                  placeholder="테이블 설명"
                  type="text"
                />
              </Field>

              {/* <Field
                required
                invalid={!!errors.description}
                errorText={errors.description?.message}
                label="Table Code"
              >
                <Input
                  id="table_code"
                  {...register("table_code")}
                  placeholder="테이블 코드 명 입력."
                  type="text"
                />
              </Field> */}
            </VStack>
          </DialogBody>

          <DialogFooter gap={2}>
            <ButtonGroup>
              <DialogActionTrigger asChild>
                <Button
                  variant="subtle"
                  colorPalette="gray"
                  disabled={isSubmitting}
                >
                  취소
                </Button>
              </DialogActionTrigger>
              <Button
                variant="solid"
                type="submit"
                disabled={!isValid || isSubmitting || hasSubmitted}
                loading={isSubmitting}
              >
                저장
              </Button>
            </ButtonGroup>
          </DialogFooter>
        </form>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};

export default AddTable;
